var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.428 1.26c-1.08 3.097-2.403 4.845-4.64 6.104-.32.18-1.246.566-2.056.861-1.542.553-1.85.733-1.696.977.051.077.745.386 1.555.681 1.799.656 2.75 1.157 3.611 1.89 1.504 1.285 2.223 2.416 3.149 4.909.732 2.018.835 2.018 1.606-.103.784-2.146 1.26-2.956 2.494-4.19 1.233-1.233 2.043-1.709 4.19-2.493 2.107-.771 2.12-.861.128-1.594-1.812-.668-2.532-1.028-3.56-1.812-1.478-1.105-2.506-2.699-3.38-5.243C9.469.206 9.353 0 9.135 0c-.232 0-.347.206-.707 1.26",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 6.157,
    y1: 19.125,
    x2: 26.155,
    y2: -9.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#077ee0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04457a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2Icon);
export default __webpack_public_path__ + "static/media/star2_icon.a31c6f73bf0073e16bbeb3e316a94e88.svg";
export { ForwardRef as ReactComponent };